const classSearchHasValue = 'search-form--has-value';

$('.search-form').each(function () {
    let $searchForm = $(this),
        $input = $(this).find('.search-form__input');

    $input.on('keyup', function () {
        let value = $(this).val();

        if (typeof value === 'undefined' || value === '') {
            $searchForm.removeClass(classSearchHasValue);
        } else {
            $searchForm.addClass(classSearchHasValue);
        }
    });
});